import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LocationSelectorComponent } from './location-selector.component';
import { GlobalsService } from '../../services/globals.service';
import { DQOIService } from '../../services/DQOI.service';
import { CustomerSelectorComponent } from '../customer-selector/customer-selector.component';
import { SharedComponentsModule } from '../../sharedComponents.module';

@NgModule({
    imports: [
        CommonModule,
        DropDownsModule,
        SharedComponentsModule
    ],
    declarations: [
        LocationSelectorComponent,
        CustomerSelectorComponent
    ],
    exports: [
        CustomerSelectorComponent,
        LocationSelectorComponent
    ]

})
export class LocationSelectorModule {
    static forRoot(): ModuleWithProviders<LocationSelectorModule> {
    return {
        ngModule: LocationSelectorModule,
        providers: [GlobalsService, DQOIService]
    };
}
}
